import { QuestionBase } from "./question-base";

export class CheckboxQuestion extends QuestionBase<string | boolean> {
  controlType = "checkbox";
}
